import script from "./HTpvpGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTpvpGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTpvpGameSetting.vue?vue&type=style&index=0&id=4b3db541&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3db541"]])

export default __exports__